// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"quickinfo_wrapper__3GmvY"};